import moment from 'moment/moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import LibDayPickerInput from 'react-day-picker/DayPickerInput';
import DATE_FORMATS from '../constants/dateFormats';

export default class DayPickerInput extends Component {
  parseDate = (dateString) => {
    if (dateString.length !== 11 && dateString.length !== 17) {
      return '';
    }
    const date = moment(dateString, DATE_FORMATS[this.props.type]);
    return date.isValid() ? date.toDate() : '';
  };

  formatDate = (date) => moment(date).format(DATE_FORMATS[this.props.type]);

  render() {
    const { value, onChange, type } = this.props;
    return (
      <LibDayPickerInput
        value={value}
        onDayChange={(date, modifiers) => {
          if (!date) {
            onChange(undefined);
          } else {
            const eventDate = moment(date);

            if (!modifiers.selected && moment(value).isSame(eventDate, 'day')) {
              onChange(date);
            } else {
              onChange(eventDate.startOf('day').toDate());
            }
          }
        }}
        formatDate={this.formatDate}
        parseDate={this.parseDate}
        placeholder={DATE_FORMATS[type]}
      />
    );
  }
}

DayPickerInput.propTypes = {
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  type: PropTypes.string,
};
